import { Button, Card, CardTitle, Input, Toaster } from "@dune/ui";
import "@dune/ui/globals.css";
import { Mail02 } from "@untitled-ui/icons-react";
import { useState } from "react";
import { toast } from "sonner";
import { useForgetPassword } from "../../api/mutations/user.mutations";

export default function ForgetPassword() {
	const [email, setEmail] = useState("");
	const {
		mutate: mutateSendEmailForgetPassword,
		isPending: isPendingSendEmailForgetPassword,
		isError: isErrorSendEmailForgetPassword,
		isSuccess: isSuccessSendEmailForgetPassword,
	} = useForgetPassword();
	const { mutate: mutateResend, isPending: isPendingResend } =
		useForgetPassword();

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		onSubmit();
	};

	const onSubmit = () => {
		if (email) {
			mutateSendEmailForgetPassword(email);
		}
	};

	return (
		<>
			<Toaster />
			<div className="bg-background-blue h-screen flex items-center justify-center">
				<div className="absolute top-0 left-0 p-6">
					<img src="/dune_white_logo.png" alt="Dune Logo" className="w-32" />
				</div>
				<div>
					{!isSuccessSendEmailForgetPassword ? (
						<Card className="p-10 flex flex-col gap-4 max-w-[480px] overflow-auto text-center">
							<CardTitle className="text-4xl">Mot de passe oublié</CardTitle>
							<div>
								Saisissez votre adresse e-mail pour réinitialiser votre mot de
								passe
							</div>
							<form onSubmit={handleSubmit} className="flex flex-col gap-4">
								<div className="flex flex-col items-start gap-1 py-4 mt-2">
									<div>Email</div>
									<Input
										placeholder="Entrez votre email"
										className="h-11"
										maxLength={100}
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										required
									/>
								</div>

								<Button
									type="submit"
									disabled={isPendingSendEmailForgetPassword || !email}
									isLoading={isPendingSendEmailForgetPassword}
									size="lg"
								>
									Réinitialiser
								</Button>

								{isErrorSendEmailForgetPassword && (
									<div className="text-red-500 text-sm mt-2">
										Echec lors de l'envoi du mail. Veuillez réessayer.
									</div>
								)}
							</form>
						</Card>
					) : (
						<Card className="p-10 flex flex-col gap-4 min-w-[450px] overflow-auto text-center">
							<Mail02 className="text-background-blue mx-auto w-[2rem] h-[2rem]" />
							<CardTitle className="text-4xl">Vérifiez vos mails</CardTitle>
							<div>Nous vous avons envoyé un email</div>

							<Button
								variant="outline"
								size="lg"
								isLoading={isPendingResend}
								disabled={isPendingResend}
								className="mt-4"
								onClick={() => {
									mutateResend(email);
									toast("Un mail a été renvoyé", {
										description:
											"Vérifiez vos mails, un mail de change de mot de passe a été renvoyé.",
									});
								}}
							>
								Renvoyer l'email
							</Button>
							<div className="flex justify-center w-full">
								<a
									href="/login"
									className="text-text-blue hover:text-blue-700 font-semibold text-sm"
								>
									Retour à la connexion
								</a>
							</div>
						</Card>
					)}
				</div>
			</div>
		</>
	);
}
